@if (_eventDetails) {
  <tr class="table-row-divided table-row-hover" (click)="collapse.toggle()">
    <td>
      <span>
        <strong [innerText]="_eventDetails.machineName"></strong>
      </span>
    </td>
    <td class="d-none d-md-table-cell">
      <span [innerText]="_eventDetails.machineLocation"></span>
    </td>
    @if (filtering.F) {
      <td>
        <span>
          <strong class="text-danger" [innerText]="_eventDetails.numberOfEvents.errors"></strong>
        </span>
      </td>
    }
    @if (filtering.W) {
      <td>
        <span>
          <strong class="text-warning" [innerText]="_eventDetails.numberOfEvents.warnings"></strong>
        </span>
      </td>
    }
    @if (filtering.I) {
      <td>
        <span>
          <strong class="text-info" [innerText]="_eventDetails.numberOfEvents.infos"></strong>
        </span>
      </td>
    }
    @if (filtering.D) {
      <td>
        <span>
          <strong class="text-debug" [innerText]="_eventDetails.numberOfEvents.debugs"></strong>
        </span>
      </td>
    }
    @if (filtering.IH) {
      <td>
        <span>
          <strong [innerText]="_eventDetails.numberOfEvents.inhibits"></strong>
        </span>
      </td>
    }
    <td class="td-expand text-center">
      <button class="btn-collapse"
        [ngClass]="isCollapsed ? 'collapsed' : 'expanded'">
        <span class="fa-solid fa-chevron-right"></span>
      </button>
    </td>
  </tr>
}


<tr #collapse="ngbCollapse" class="table-secondary" [animation]="false" [(ngbCollapse)]="isCollapsed">
  @if (_eventDetails) {
    <td colspan="8" class="p-4">
      <scitis-machine-status-events-table (redirectToStatusPage)="redirectToStatusPage($event)" (loadMore)="onLoadMoreEvents()" [statusEvents]="statusEventPageData" [isLoading]="isLoading">
      </scitis-machine-status-events-table>
      @if (!_eventDetails.totalCount) {
        <div class="alert alert-info mb-0 text-center">
          <span translate>There are no current status messages for this machine.</span>
        </div>
      }
    </td>
  }
</tr>
